import { Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { AgencyPf, Apresentacao, PfIndicator } from '../../models/apresentacao.model';
import { ApresentacaoQuadroGeralComponent } from '../apresentacao-quadro-geral/apresentacao-quadro-geral.component';
import { ApresentacaoSlideComponent } from '../apresentacao-slide/apresentacao-slide.component';
import { forkJoin, from, Observable, take } from 'rxjs';

@Component({
  selector: 'app-apresentacao-relatorio',
  templateUrl: './apresentacao-relatorio.component.html',
  styleUrls: ['./apresentacao-relatorio.component.scss']
})
export class ApresentacaoRelatorioComponent extends BaseFormComponent<Apresentacao> implements OnInit {

  id:number;
  agencys:AgencyPf[] = [];

  @Output() generatePDF = new EventEmitter<void>();
  @ViewChild(ApresentacaoQuadroGeralComponent) quadroGeral: ApresentacaoQuadroGeralComponent;
  @ViewChildren(ApresentacaoSlideComponent) slides!: QueryList<ApresentacaoSlideComponent>;

  constructor(
    public activatedRoute: ActivatedRoute,
    private apresentacaoResolverId: ApresentacaoResolverId
  ) {
    super(activatedRoute); 
   }

  ngOnInit() {
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.start();
  }

  start(){
    this.agencys = []
    this.apresentacaoResolverId.getById( this.id ).subscribe({
        next: (data) => {
          this.entity = data;data?.agencyPf?.forEach(ag => {
            var agencyMany = ag?.tb_org_orgao_many; 
            var filterAgencies = data.currentFilter?.agency_id ?? [];
            if(agencyMany && agencyMany.length >0){
              agencyMany.forEach(agm =>{
                var indicators:PfIndicator[] = [];
                if(filterAgencies.includes(agm['num_codigo_pk'])){
                  agm.project_full.forEach(pf =>{
                    pf.pf_indicator.forEach((ind, i) =>{
                      console.log(pf)
                      indicators.push( { ...ind, project: pf, agency:agm, index: i });
                    });
                    indicators.push();
                  });
                }
                this.agencys.push({...agm, 'indicators': indicators});
              })
            }
            else{
              if(filterAgencies.includes(ag['num_codigo_pk'])){
                var indicators:PfIndicator[] = [];
                ag.project_full.forEach(pf =>{
                  pf.pf_indicator.forEach(ind =>{
                    indicators.push( { ...ind, project: pf, agency:ag});
                  });
                });
                this.agencys.push({...ag, 'indicators': indicators});
              }
            }
          })
        },
        error: (error) => {
          console.log(error)
          this.msgError(error.error.message);
        }
      })
  }
  ngAfterViewInit(){
    const observables: Observable<void>[] = [];
    var test: Observable<void>;
    if (this.quadroGeral?.graficoCarregado) {
      observables.push(this.quadroGeral.graficoCarregado);
    }
    this.slides.forEach((slide,i) => {
      if (slide?.graficoCarregado) {
        observables.push(slide.graficoCarregado); 
      }
    });
    forkJoin(observables.map(obs => obs.pipe(take(1)))).subscribe({
      next: () => {
        console.log('fechou')
          this.generatePDF.emit();
      },
      error: (err) => {
          console.error("Erro ao carregar gráficos:", err);
      }
    });
  }
}